import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const Hero = () => {
  const { t, i18n } = useTranslation();
  const [current, setCurrent] = useState(0);
  const phoneNumber = "+923158182288";
  const whatsappNumber = "923158182288";

  // Slides translated
  const slides = [
    {
      title: t("hero.slide1.title"),
      desc: t("hero.slide1.desc"),
    },
    {
      title: t("hero.slide2.title"),
      desc: t("hero.slide2.desc"),
    },
    {
      title: t("hero.slide3.title"),
      desc: t("hero.slide3.desc"),
    },
    {
      title: t("hero.slide4.title"),
      desc: t("hero.slide4.desc"),
    },
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 6000);
    return () => clearInterval(timer);
  }, [slides.length]);

  // ✅ Make Hero re-render when language changes
  useEffect(() => {
    setCurrent(0);
  }, [i18n.language]);

  return (
    <section
      key={i18n.language} // ✅ forces clean re-render when switching languages
      className={`
        relative min-h-[70vh] md:min-h-[80vh] flex flex-col items-center justify-center text-center px-6
        bg-gradient-to-br from-[#000814] via-[#001d3d] to-[#003566]
        overflow-hidden ${i18n.language === "ur" ? "font-ur" : ""}
      `}
      dir={i18n.language === "ur" ? "rtl" : "ltr"}
    >
      <motion.div
        key={current}
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -30 }}
        transition={{ duration: 0.8 }}
        className="max-w-4xl mx-auto px-4"
      >
        {/* Heading */}
        <h1
          className="
            text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight text-white
            bg-gradient-to-r from-sky-400 via-blue-500 to-sky-600 text-transparent bg-clip-text
            mb-6
          "
        >
          {slides[current].title}
        </h1>

        {/* Description */}
        <p
          className="
            text-gray-300 text-base sm:text-lg md:text-xl leading-relaxed max-w-2xl mx-auto
            mb-10
          "
        >
          {slides[current].desc}
        </p>

        {/* ✅ Buttons (only rendered once) */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href={`tel:${phoneNumber}`}
            className="px-8 py-3 bg-gradient-to-r from-blue-700 via-sky-500 to-blue-600 text-white font-semibold rounded-full shadow-lg hover:shadow-sky-500/50 hover:scale-105 transition duration-300"
          >
            📞 {t("hero.call")}
          </a>
          <a
            href={`https://wa.me/${whatsappNumber}`}
            target="_blank"
            rel="noopener noreferrer"
            className="px-8 py-3 bg-green-600 text-white font-semibold rounded-full shadow-lg hover:bg-green-500 hover:shadow-green-400/50 hover:scale-105 transition duration-300"
          >
            💬 {t("hero.whatsapp")}
          </a>
        </div>
      </motion.div>

      <div className="absolute inset-0 bg-gradient-to-t from-blue-900/10 to-transparent pointer-events-none" />
    </section>
  );
};

export default Hero;
